import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomCookieService } from './cookies.service';
import { switchMap, catchError, throwError, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient, private cookieService: CustomCookieService) { }

  refreshToken(): Observable<string> {
    const refreshUrl = environment.authUrl;
    const refreshData = {
      token: this.cookieService.getCookie('authToken')
    };

    return this.http.post<{ token: string }>(refreshUrl, refreshData, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-API-KEY': this.cookieService.getCookie('apiKey')
      },
      observe: 'response'
    }).pipe(
      switchMap((response) => {
        let newToken;
        switch (response.status) {
          case 200:
            newToken = response.body.token;
            break;
          case 400:
            console.error('400 (Bad Request) occurred during token refresh');
            throw new Error('Bad Request during token refresh');
          case 401:
            console.error('401 (Unauthorized) occurred during token refresh');
            throw new Error('Unauthorized during token refresh');
          case 403:
            console.error('403 (Forbidden) occurred during token refresh');
            throw new Error('Forbidden during token refresh');
          default:
            console.error('unexpected status code during token refresh');
            throw new Error('Unexpected status code during token refresh');
        }
        return of(newToken);
      }),
      catchError((error: any) => {
        console.error('Error occurred during refreshToken', error);
        return throwError(() => error);
      })
    );
  }
}
